import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/** Shell for pages shown outside the console: authentication, maintenance, errors. */
@Component({
  selector: 'app-blank',
  standalone: true,
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div class="blank-layout"><router-outlet /></div>`,
  styles: `
    .blank-layout {
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
    }
  `,
})
export class BlankComponent {}
